import { useMutation } from '@apollo/client/react';
import { DataTableAddButton } from '@optools/components/data-table/data-table-add-button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@optools/components/ui/dialog';
import { CREATE_PLAYBACK_OVERRIDE } from '@optools/services/operator-gateway/overrides/playback/mutations';
import { GET_PLAYBACK_OVERRIDES } from '@optools/services/operator-gateway/overrides/playback/queries';
import { ClientType, MatchParams } from '@optools/services/operator-gateway/overrides/types';
import { useState } from 'react';
import { toast } from 'sonner';

import { PlaybackOverrideForm, PlaybackOverrideFormValues } from './playback-override-form';

export function CreatePlaybackOverride() {
  const [open, setOpen] = useState(false);

  const [createPlaybackOverride, { loading }] = useMutation(CREATE_PLAYBACK_OVERRIDE, {
    awaitRefetchQueries: true,
    onCompleted: ({ createPlaybackOverride }) => {
      if (!createPlaybackOverride) {
        toast.error('Create Override Error', {
          description: 'Failed to create override, please try again',
          duration: Infinity,
        });
      } else {
        toast.success('Playback Override successfully created');

        setOpen(false);
      }
    },
    refetchQueries: [{ query: GET_PLAYBACK_OVERRIDES }],
  });

  const handleClose = (nextOpen: boolean) => {
    if (loading) return;
    setOpen(nextOpen);
  };

  const handleSubmit = (values: PlaybackOverrideFormValues) => {
    const matchParams: MatchParams = {};
    const { clientType, experience, features, userId } = values;

    if (clientType !== ClientType.ALL_CLIENTS) matchParams.clientType = clientType;
    if (userId) matchParams.userId = userId;

    createPlaybackOverride({ variables: { experience, features, matchParams } });
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogTrigger asChild>
        <DataTableAddButton>Create Override</DataTableAddButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Override</DialogTitle>
          <DialogDescription className="sr-only">Create a new override</DialogDescription>
        </DialogHeader>
        <PlaybackOverrideForm loading={loading} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}
